import React from 'react';
import HeroBanner from '../components/home/HeroBanner';
import FeaturedCompanies from '../components/home/FeaturedCompanies';
import LatestJobs from '../components/home/LatestJobs';
import CompanyInitiatives from '../components/home/CompanyInitiatives';
import CtaSection from '../components/home/CtaSection';
import LatestBlogs from '../components/home/LatestBlogs';
import LatestVideos from '../components/home/LatestVideos';
import Testimonials from '../components/home/Testimonials';
import NewsletterCta from '../components/home/NewsletterCta';
import ValuesCta from '../components/home/ValuesCta';

const Home = () => {
  return (
    <>
      <HeroBanner />
      <FeaturedCompanies />
      <LatestJobs />
      <CompanyInitiatives />
      <CtaSection />
      <LatestBlogs />
      <LatestVideos />
      <Testimonials />
      <NewsletterCta />
      <ValuesCta />
    </>
  );
};

export default Home;